

























































































import { mapState } from "vuex";
import InputText from "@/common/components/atoms/InputText.vue";
import InputCheckBox from "@/common/components/atoms/InputCheckBox.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import {
  required,
  max_value,
  min_value,
  numeric,
  min
} from "vee-validate/dist/rules";
import LocalStorage from "@/general/utils/storage";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});

extend("max_value", {
  ...max_value,
  message: "{_field_}は {max} 以下でなければなりません。"
});

extend("min_value", {
  ...min_value,
  message: "{_field_}は {min} 以上でなければなりません。"
});

extend("numeric", {
  ...numeric,
  message: "数字で入力してください。"
});

@Component({
  components: {
    InputText,
    InputCheckBox,
    CommonHeading,
    ButtonMain,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  }
})
export default class TheB01SearchPanel extends Vue {
  @Prop({ type: Object, required: false }) currentCategory!: any;
  @Prop({ type: Object, required: false }) currentCategoryChild!: any;
  @Prop({ type: String, required: false }) searchKeyword!: string;
  @Prop({ type: Number, required: true }) maxPointSearchable!: number;
  @Prop({ type: String, required: false, default: "" }) searchFrom!: any;
  @Prop({ type: String, required: false, default: "" }) searchTo!: any;
  @Prop({ type: Boolean, required: false, default: false })
  isUsableRange!: boolean;
  @Prop({ type: Boolean, required: false }) haveItem!: boolean;
  @Prop({ type: Boolean, required: true }) showMainCategoryActive!: boolean;
  @Ref("form") form!: HTMLFormElement;

  internalIsUsableRange = false;
  disableMinMaxInputs = false;
  showInputValidationError = false;

  get activeColor() {
    return commons.OrgPageSpecific?.page_color;
  }
  get color() {
    return commons.OrgPageSpecific?.page_color;
  }

  get point() {
    return commons.OrgPageSpecific?.point_name;
  }

  onCheck() {
    this.internalIsUsableRange = !this.internalIsUsableRange;

    if (this.internalIsUsableRange) {
      this.disableMinMaxInputs = true;
      LocalStorage.setItem("usableRange", "1");
    } else {
      this.disableMinMaxInputs = false;
      LocalStorage.removeItem("usableRange");
    }
  }

  @Watch("internalSearchFrom")
  onInternalSearchFrom() {
    console.log("text");
  }

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      const userPoints = this.getUserPoints();
      if (
        (parseInt(this.searchFrom) < 0 ||
          parseInt(this.searchTo) < 0 ||
          this.searchFrom == "" ||
          this.searchTo == "") &&
        !this.internalIsUsableRange
      ) {
        this.showInputValidationError = true;
      } else {
        this.showInputValidationError = false;
        let min;
        let max;
        if (this.internalIsUsableRange === true) {
          min = "0";
          max = userPoints.toString();
        } else {
          min = this.searchFrom;
          max = this.searchTo;
        }

        this.$emit("update:search-from", this.searchFrom);
        this.$emit("update:search-to", this.searchTo);
        LocalStorage.setItem("poductListMinPoint", min);
        LocalStorage.setItem("poductListMaxPoint", max);
        const value = {
          min,
          max
        };
        this.$emit("min-max-form", value);
      }
    });
  }

  getUserPoints() {
    const userPoints = LocalStorage.getItem("userPointsDetails")
      ? JSON.parse(LocalStorage.getItem("userPointsDetails") as string)
      : [];

    if (userPoints.total_points) {
      return userPoints.total_points - userPoints.thanks_exclusive_points;
    } else {
      return 0;
    }
  }

  clickOnSubcategory(id: number) {
    this.$emit("update:showMainCategoryActive", false);
    this.$emit("click-subcategory-upper", id);
  }

  async created() {
    if (
      LocalStorage.getItem("usableRange") != null &&
      LocalStorage.getItem("usableRange") == "1"
    ) {
      this.internalIsUsableRange = true;
      this.disableMinMaxInputs = true;
    } else {
      this.disableMinMaxInputs = false;
      this.internalIsUsableRange = false;
    }
  }
}
